// Custom icon static resources

import { AppstoreOutline } from '@ant-design/icons-angular/icons';

export const ICONS = [AppstoreOutline];
